<div class="iframe-container">
  <iframe [src]="safeUrl" webkitallowfullscreen mozallowfullscreen allowfullscreen>
  </iframe>
</div>
